'use client'

// The global page ground (fixed, behind everything). Theme-aware (2026-10-21): the base flips via the
// `background` token, and the two decoration sets swap on the `dark:` class. Dark is the default, so the
// dark set below is the original look, unchanged.
export default function BackgroundLayers() {
  return (
    <div className="fixed inset-0 -z-10 overflow-hidden bg-background">
      {/* DARK — original decorations, shown only when <html> has the dark class */}
      <div className="absolute inset-0 hidden dark:block">
        {/* [BG] Subtle gradient mesh */}
        <div className="absolute inset-0 opacity-75">
          <div className="absolute top-0 -left-1/4 w-1/2 h-1/2 bg-gradient-to-r from-purple-500/10 to-transparent rounded-full blur-[100px]" />
          <div className="absolute bottom-0 -right-1/4 w-1/2 h-1/2 bg-gradient-to-l from-blue-500/10 to-transparent rounded-full blur-[100px]" />
        </div>
        {/* [STATS] Ultra-subtle grid (white hairlines on the dark ground) */}
        <div className="absolute inset-0 opacity-[0.02]">
          <div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.05)_1px,transparent_1px),linear-gradient(to_right,rgba(255,255,255,0.05)_1px,transparent_1px)] bg-[size:64px_64px]" />
        </div>
        {/* [*] Premium noise texture */}
        <div className="absolute inset-0 bg-noise opacity-[0.015] mix-blend-overlay" />
        {/* [*] Vignette effect */}
        <div className="absolute inset-0 bg-radial-gradient pointer-events-none" />
      </div>

      {/* LIGHT — default. Clean white with soft brand-tinted glows and a whisper-faint grid. */}
      <div className="absolute inset-0 dark:hidden">
        <div className="absolute inset-0 opacity-70">
          <div className="absolute top-0 -left-1/4 w-1/2 h-1/2 bg-gradient-to-r from-amber-200/40 to-transparent rounded-full blur-[120px]" />
          <div className="absolute bottom-0 -right-1/4 w-1/2 h-1/2 bg-gradient-to-l from-sky-200/40 to-transparent rounded-full blur-[120px]" />
        </div>
        {/* dark hairlines on the light ground */}
        <div className="absolute inset-0 opacity-[0.04]">
          <div className="absolute inset-0 bg-[linear-gradient(rgba(9,9,11,0.5)_1px,transparent_1px),linear-gradient(to_right,rgba(9,9,11,0.5)_1px,transparent_1px)] bg-[size:64px_64px]" />
        </div>
      </div>
    </div>
  )
}
